import React from 'react';
import './LandingPage2.css';

const VirtualInfluencer = () => {
  return (
    <div className="LandingPage divmain">
      <header>
        <div className="container">
          <h1>CREA IL TUO INFLUENCER VIRTUALE E GUADAGNA CON PSICOPATICI ITALIA</h1>
          <p className='mb-0'>Sei un giovane talento pronto a dominare il mondo della moda digitale?</p>
          <p>Diventa parte del nostro programma esclusivo di partnership e crea il tuo influencer virtuale!</p>
        </div>
      </header>

        <section className="how-it-works">
            <div className="container">
                <h2>Come iniziare a guadagnare come Partner Virtual Influencer?</h2>
                <div className="cards-container">
                    {[
                        {
                            title: "Inizia a promuoverti",
                            desc: "Registrati, ricevi il tuo link/codice e inizia a pubblicare contenuti"
                        },
                        {
                            title: "Guadagna su ogni acquisto",
                            desc: "Fino al 24% di commissioni su ogni vendita"
                        },
                        {
                            title: "Ottieni bonus extra",
                            desc: "0,50 € per ogni registrazione cliente tramite il tuo link"
                        }
                    ].map((item, i) => (
                        <div key={i} className="card1" style={{ display: "flex", flexDirection: "column" }}>
                            <p><strong>{item.title}</strong></p>
                            <p style={{ color: "gray", fontSize: "12px" }}>{item.desc}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-4">
                    <h5>💰 Dettaglio Commissioni:</h5>
                    <div className="cards-container">
                        {[
                            { range: "0–50 acquisti", value: "15%" },
                            { range: "51–300 acquisti", value: "18%" },
                            { range: "301–1000 acquisti", value: "21%" },
                            { range: "Oltre 1000 acquisti", value: "24%" }
                        ].map((item, i) => (
                            <div key={i} className="card1" style={{ display: "flex", flexDirection: "column" }}>
                                <p><strong>{item.range}</strong></p>
                                <p style={{ color: "gray", fontSize: "14px" }}>{item.value} di commissione</p>
                            </div>
                        ))}
                    </div>
                    <p className="mt-3" style={{ fontSize: "14px" }}>
                        📌 Guadagni automatici per 12 mesi su ogni cliente acquisito, anche senza ulteriori clic.
                    </p>
                </div>
            </div>
        </section>

        <section className="how-it-works">
            <div className="container">
                <h2>Perché diventare Partner Virtual Influencer?</h2>
                <div className="cards-container">
                    {[
                        "✅ Nessun investimento iniziale",
                        "🔗 Link o codice affiliato personale",
                        "🎭 Possibilità di usare volto reale o avatar",
                        "🧠 Supporto creativo e materiali promozionali",
                        "📈 Provvigioni in crescita con i risultati",
                        "📦 Accesso anticipato ai nuovi prodotti (prossimamente)"
                    ].map((text, i) => (
                        <div key={i} className="card1">
                            <p>{text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>


        <section className="how-it-works">
            <div className="container">
                <h2>I benefici riservati ai nostri partner</h2>
                <div className="cards-container">
                    {[
                        "🎟️ Inviti a eventi e iniziative riservate",
                        "📊 Dashboard e report avanzati in tempo reale",
                        "📚 Accesso completo alla Libreria Virtuale",
                        "🏆 Possibilità di diventare ambassador ufficiale"
                    ].map((text, i) => (
                        <div key={i} className="card1">
                            <p>{text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>

        {/* REQUISITI */}
        <section className="how-it-works">
            <div className="container">
                <h2>Chi può diventare Partner Virtual Influencer?</h2>
                <div className="cards-container">
                    <div className="card1">
                        <p>✔️ Presenza social attiva e in linea con il brand</p>
                    </div>
                    <div className="card1">
                        <p>✔️ Micro-influencer con contenuti autentici e costanti</p>
                    </div>
                    <div className="card1">
                        <p>✔️ Creatori digitali con forte senso dello stile</p>
                    </div>
                    <div className="card1">
                        <p>✔️ Appassionati di moda, cultura urbana o streetwear</p>
                    </div>
                    <div className="card1">
                        <p>✔️ Persone carismatiche che amano condividere la propria visione del mondo</p>
                    </div>
                </div>
            </div>
        </section>

      <section style={{paddingLeft: "2%", paddingRight: "2%"}} className='container mb-5 mt-5'>
                <link href="https://campaign.huberway.com/core/css/embedded.css" rel="stylesheet" type="text/css" /><link href="https://fonts.googleapis.com/icon?family=Material+Icons+Outlined" rel="stylesheet" />
                <div class="subscribe-embedded-form">
                    <h2 style={{color: "black"}} class="mt-0 text-center h_title wow fadeInUp">Candidati Ora</h2>
                    <form action="https://campaign.huberway.com/lists/67b5f57b47539/embedded-form-subscribe-captcha" method="POST" class="form-validate-jqueryz" novalidate="novalidate">
                        <div class="form-group control-text">
                            <label> Nome e Cognome <span class="text-danger">*</span></label><input id="NAME" placeholder="" type="text" name="NAME" class="form-control required" />
                        </div>
                        <div class="form-group control-text">
                            <label> Email <span class="text-danger">*</span></label><input id="EMAIL" placeholder="" type="text" name="EMAIL" class="form-control required email:rfc,filter" />
                        </div>
                        <div class="form-group control-text">
                            <label>  Istituto Scolastico <span class="text-danger"></span></label><input id="ISTITUTO" placeholder="" type="text" name="ISTITUTO" class="form-control" />
                        </div>
                        <div class="form-group control-textarea">
                          <label> Raccontaci la tua idea <span class="text-danger">*</span>
                          </label>
                          <textarea type="text" name="IDEA" class="form-control required ">
                          </textarea>
                        </div>
                        <div class="form-button text-center"><button class="action_btn">Invia</button></div>
                    </form>
                </div>
          </section>

      <footer/>
    </div>
  );
};

export default VirtualInfluencer;
